<template>
  <div>
    <section class="list">
      <div class="mar_b10">
        ATM 명 : <span style="font-weight: bold;">{{ atmName }}</span>
        <br />
        수납된 갯수 <span style="font-weight: bold; color: tomato;">총 {{ totalCnt }} 개</span>
      </div>
      <div class="tbl">
        <div class="grid-container" style="margin-bottom: 10px;">
          <template>
            <div class="grid-item grid-header-line-height disp-flex checkbox-div-align">
              <input
                id="allCheck"
                type="checkBox"
                name="allCheck"
                :checked="allCheck"
                @click="handleAllCheckClick"
              />
              <label for="allCheck"></label>
            </div>
            <div
              class="grid-item grid-header-line-height"
              style="grid-column: 2 / 4; text-align: left;"
            >
              <div style="width: 70%;" @click="handleAllCheckClick({target: { checked: !allCheck } })">
                전체 선택
              </div>
            </div>
          </template>
        </div>
        <div :style="{ maxHeight: `${maxHight}px`, overflow: 'auto' }">
          <div
            v-for="(releaseItem, releaseIdx) in releaseList"
            :key="`releaseItem-chk-${releaseIdx}`"
            class="grid-container border-top"
            @click.prevent="e => handleItemCheckClick(releaseIdx)"
          >
            <div  class="grid-item disp-flex checkbox-div-align">
              <input
                type="checkBox"
                :id="`check_${releaseIdx}`"
                :checked="checkValList[releaseIdx]"
              />
              <label :for="`check_${releaseIdx}`"></label>
            </div>
            <div class="grid-item taL" style="grid-column: 2 / 5;">
              <P style="color: gray; margin-bottom: 6px;">
                {{releaseItem.ord_num}}
                <br />
                {{releaseItem.ord_number}}
              </P>
              <span style="font-weight: bold;">
                {{ releaseItem.model_no }}
              </span>
            </div>
            <div class="grid-item disp-flex taL row_ac" style="grid-column: 5 / 7;">
              {{ releaseItem.reg_date.split(' ')[0] }}
              <br />
              {{ releaseItem.reg_date.split(' ')[1] }}
            </div>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div class="bottom-button-div">
        <button
          class="btn btn_type_01 font13"
          style="width: 50%; background-color: #2bd3c6; color: #fff"
          @click="handleNextClick"
        >
          수량입력
        </button>
      </div>
    </section>
    <CountInput @popupComplete="compareCntRelease"/>
    <Camera @popupComplete="cameraJobDone"/>
  </div>
</template>

<script>
import Camera from '@/components/Camera.vue'
import CountInput from './CountInput.vue'

export default {
  name: 'list',
  props: {
    releaseList: {
      type: Array,
      default: () => []
    },
    atmName: {
      type: String,
      default: ''
    }
  },
  components: {
    CountInput,
    Camera
  },
  data: () => ({
    allCheck: false,
    checkValList: [],
    param: {},
    filesReders: [],
    files: [],
    isUseCamera: true
  }),
  computed: {
    maxHight () {
      if (window) {
        return window.innerHeight * 0.5
      }
      return 500
    },
    totalCnt () {
      return this.releaseList.length
    },
    checkedItemList () {
      return this.checkValList.filter(key => key)
    }
  },
  created () {

  },
  mounted () {

  },
  watch: {
    releaseList (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.allCheck = newVal.length > 0
        this.checkValList = newVal.map(_obj => true)
      }
    },
    filesReders (newVal, oldVal) {
      if (newVal !== oldVal && newVal.length > 0) {
        this.$emit('imageUpload', { filesReders: this.filesReders, files: this.files, param: this.param })
        document.getElementById('fileUploadEl').value = ''
        document.getElementById('fileUploadEl').files = null
        this.filesReders = []
        this.files = []
      }
    }
  },
  methods: {
    async getCommonCode (cmnsCdGrpId) {
      const params = { cmnsCdGrpId }
      const res = await this.$http.get('/api/appmgmt/common/code/list', { params })

      if (res) {
        const { data: { result } } = res

        if (result && result.length > 0) {
          result.forEach(obj => {
            if (obj.cmnsCd === 'IS_USE_CAM') {
              this.isUseCamera = obj.cmnsCdNm === 'Y'
            }
          })
        }
      }
    },
    handleAllCheckClick (e) {
      const { target: { checked } } = e
      this.allCheck = checked
      this.checkValList = this.releaseList.map(_obj => checked)
    },
    handleItemCheckClick (trgtIdx) {
      const checked = this.checkValList[trgtIdx]

      this.checkValList.splice(trgtIdx, 1, !checked)

      const isAllcheckValList = this.checkValList.filter(val => val).length === this.releaseList.length
      this.allCheck = isAllcheckValList
    },
    handleNextClick () {
      // db 상 0개가 있는 경우도 있음... by 담당자
      // if (!this.checkedItemList.length) {
      //   this.$Alert.confirm('체크된 회수 기기가 없습니다.')
      //     .then(res => {
      //       if (res) {
      //         this.$modal.show('countInput')
      //       }
      //     })
      //   return
      // }

      this.$modal.show('countInput', { checkedItem: this.checkedItemList })
    },
    async handleOpenAtmClick () {
      await this.$Alert.alert('준비중')
    },
    handleAtmMntcClick () {
      this.$router.push({path: '/customerCare/atmMntcHstrInsert'})
    },
    compareCntRelease ({ cntRelease }) {
      this.getCommonCode('RECL_SETT_CD')
      this.makeCollectParam(cntRelease)

      if (cntRelease === this.checkedItemList.length) {
        this.$emit('callCollectApi', this.param)
        return
      }

      if (!this.isUseCamera) {
        this.$emit('callCollectApi', this.param)
        return
      }
      this.$Alert.confirm('회수 단말기 10대 씩 후면을 촬영해주세요.').then((res) => {
        if (res) {
          this.$modal.show('cameraModal', { limitCnt: 10 })
        }
      })
    },
    cameraJobDone (files) {
      this.$emit('imageUpload', { files, ...this.param })
    },
    makeCollectParam (cnt_release) {
      const trgtIdxList = []
      this.checkValList.forEach((key, idx) => {
        if (key) trgtIdxList.push(idx)
      })

      const ord_num_arr = []
      trgtIdxList.forEach(key => {
        ord_num_arr.push(this.releaseList[key].ord_num)
      })

      Object.assign(this.param, {
        ord_num_arr,
        cnt_release
      })
    }
  }
}
</script>

<style scoped>
  .grid-container {
    display: grid;
    grid-template-columns: 45px repeat(5, 1fr); /* 12개의 열을 생성 */
    gap: 5px; /* 셀 간격 설정 */
    margin-top: 2px;
    margin-bottom: 10px;
  }
  .border-top {
    border-top: 1px solid #ccc;
  }
  .grid-header-line-height {
    line-height: 35px;
  }
  .grid-2Cell-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr); /* 12개의 열을 생성 */
    gap: 2px; /* 셀 간격 설정 */
  }
  .grid-item {
    padding: 2px;
    text-align: center;
  }
  .disp-flex {
    display: flex;
  }
  .checkbox-div-align {
    justify-content: center;
    align-items: center;
  }
  input[type="checkbox"]{
    display: none;
  }
  input[type="checkbox"] + label{
    display: inline-block;
    width: 30px;
    height: 30px;
    border:3px solid #707070;
    position: relative;
  }
  input[type="checkbox"]:checked + label::after{
    content:'✔';
    font-size: 25px;
    width: 30px;
    height: 30px;
    text-align: center;
    position: absolute;
    left: -3px;
    top: -6px;
    color: #2bd3c6;
  }
  .bottom-button-div {
    position: fixed;
    bottom: 0;
    left: 0px;
    display: flex;
    justify-content: center;
    width: 100%;
    padding: 1.25rem;
    background-color: #F6F9FC;
    padding-bottom: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/views/atm/collect/list.vue